import { render, staticRenderFns } from "./batchDepartDialog.vue?vue&type=template&id=698a76b1&scoped=true"
import script from "./batchDepartDialog.vue?vue&type=script&lang=js"
export * from "./batchDepartDialog.vue?vue&type=script&lang=js"
import style0 from "./batchDepartDialog.vue?vue&type=style&index=0&id=698a76b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698a76b1",
  null
  
)

export default component.exports